import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCadence = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_86",
		"data-name": "Group 86",
		transform: "translate(-141.595 -223.911)",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_85",
				"data-name": "Group 85",
				transform: "translate(149.749 226.099)",
				children: [/* @__PURE__ */ _jsx("g", {
					id: "Path_2152",
					"data-name": "Path 2152",
					transform: "translate(0 8.544)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_208",
						"data-name": "Path 208",
						d: "M166.639,264.019c-1.769,0-2.142-2.219-2.325-3.312-.033-.2-.062-.372-.094-.515-.042-.184-.142-.5-.248-.828a10.246,10.246,0,0,1-.62-2.755,4.607,4.607,0,0,1,1.263-3.348,2.563,2.563,0,0,1,1.977-.7c1.562.113,2.38,1.8,2.38,3.408a6.063,6.063,0,0,1-.316,1.845,3.343,3.343,0,0,0-.194.962,8.943,8.943,0,0,0,.127,1.158c.172,1.155.367,2.465-.3,3.335a1.952,1.952,0,0,1-1.384.739A2.308,2.308,0,0,1,166.639,264.019Zm-.245-9.971a1.076,1.076,0,0,0-.757.311,3.2,3.2,0,0,0-.785,2.251,9.625,9.625,0,0,0,.548,2.3c.121.38.227.708.283.958.037.165.072.369.11.595.214,1.275.448,2.116.941,2.055h0c.269-.031.341-.126.368-.161.28-.365.122-1.427.006-2.2a9.82,9.82,0,0,1-.144-1.379,4.658,4.658,0,0,1,.256-1.39,4.594,4.594,0,0,0,.253-1.417c0-.886-.378-1.869-.989-1.913Q166.438,254.048,166.394,254.048Z",
						transform: "translate(-163.352 -252.549)",
						fill: "current"
					})
				}), /* @__PURE__ */ _jsx("g", {
					id: "Path_2153",
					"data-name": "Path 2153",
					transform: "translate(7.42 0)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_209",
						"data-name": "Path 209",
						d: "M185.483,241.219a2.378,2.378,0,0,1-.268-.016h0a1.949,1.949,0,0,1-1.384-.739c-.666-.869-.471-2.179-.3-3.335a8.884,8.884,0,0,0,.127-1.158,3.343,3.343,0,0,0-.194-.962,6.062,6.062,0,0,1-.316-1.845c0-1.608.818-3.295,2.381-3.408a2.563,2.563,0,0,1,1.976.7,4.6,4.6,0,0,1,1.263,3.348,10.252,10.252,0,0,1-.619,2.753c-.106.331-.206.645-.247.829-.033.144-.062.321-.095.517C187.625,239,187.251,241.219,185.483,241.219Zm-.093-1.5c.479.058.726-.78.941-2.055.038-.226.073-.43.11-.6.055-.25.161-.578.282-.959a9.593,9.593,0,0,0,.548-2.3,3.2,3.2,0,0,0-.784-2.25,1.078,1.078,0,0,0-.847-.308c-.611.045-.99,1.028-.99,1.913a4.585,4.585,0,0,0,.253,1.417,4.658,4.658,0,0,1,.256,1.39,9.861,9.861,0,0,1-.143,1.378c-.116.776-.274,1.838.006,2.2.027.035.1.129.368.161Z",
						transform: "translate(-183.15 -229.749)",
						fill: "current"
					})
				})]
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_22",
				"data-name": "Rectangle 22",
				width: 24,
				height: 24,
				transform: "translate(141.595 223.911)",
				fill: "none"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_210",
				"data-name": "Path 210",
				d: "M150.263,244.556l-2-2a.746.746,0,0,0-.115-.094c-.018-.012-.037-.02-.056-.03s-.048-.028-.073-.039a.754.754,0,0,0-.075-.023c-.022-.006-.042-.015-.065-.019a.743.743,0,0,0-.293,0c-.022,0-.043.013-.065.019a.746.746,0,0,0-.075.023c-.026.011-.049.026-.073.039s-.038.018-.056.03a.726.726,0,0,0-.115.094l-2,2a.75.75,0,1,0,1.06,1.06l.717-.717v7.568a.75.75,0,1,0,1.5,0V244.9l.717.717a.75.75,0,1,0,1.06-1.06Z",
				transform: "translate(-2.123 -11.523)",
				fill: "current"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgCadence);
export { ForwardRef as ReactComponent };
